exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-title-wrapper[data-v-3f295db8]{width:100%}h1[data-v-3f295db8]{font-size:22px}h1.edit-d-title[data-v-3f295db8]:after{background:transparent;right:-40px;color:#cbd3cb}textarea.title-field[data-v-3f295db8]{font-size:2.25rem}", ""]);

// exports
